import * as React from "react";
const SvgFiRrUnicorn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-unicorn_svg__a)">
      <path
        fill="#062147"
        d="M22.79 6.764c-1.511-.65-2.604-1.52-3.266-2.596L23.733.694c.349-.33.006-.904-.45-.752L19 1.506V.873c0-.592-.596-1.04-1.143-.814-.875.361-1.542 1.231-1.771 2.208C12.96 3.232 12.027 6.582 12 8.5a.5.5 0 0 1-.5.5H8.015a4.03 4.03 0 0 0-3.14 1.503c-.017.003-.042.011-.006.006-2.136.717-4.87 2.81-4.87 8.491a1 1 0 1 0 2 0c0-2.796.671-4.748 1.997-5.83.043 1.597.648 3.333 1.139 4.737.146.417.284.812.396 1.173l-.213 1.543a2.968 2.968 0 1 0 5.889.775L11.382 20h1.617v1c0 1.654 1.346 3 3 3s3-1.346 3-3v-2.396l.385-1.81c.417-1.46.615-2.416.615-3.896v-2.016l2.237-.28a2.016 2.016 0 0 0 1.763-1.997c0-.804-.476-1.527-1.21-1.842zm-3.038 2.134A2 2 0 0 0 18 10.882v2.016c0 1.25-.166 2.042-.555 3.412l-.423 1.98a1 1 0 0 0-.022.21V21a1 1 0 0 1-2 0v-2a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-.992.875l-.284 2.274a.97.97 0 0 1-.962.85.96.96 0 0 1-.731-.333.96.96 0 0 1-.229-.77l.243-1.76c.019-.14.009-.283-.031-.419-.129-.442-.303-.94-.489-1.472-.483-1.384-1.031-2.95-1.03-4.258.001-1.097.908-1.989 2.021-1.989h3.485c1.378 0 2.5-1.122 2.5-2.483.009-.43.175-3.984 3.245-4.463.749 1.984 2.345 3.514 4.744 4.565l-2.237.28z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-unicorn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUnicorn;
